import React, { useState } from "react";
import axios from "axios";
import "./ApiKey.css";

const ApiKey = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const generateKey = async () => {
    if (!user?.user_code) {
      alert("User not logged in");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        "https://vahanapi.site/api/generate_api_key.php",
        { user_code: user.user_code }
      );

      if (res.data.status && res.data.api_key) {
        setApiKey(res.data.api_key);
        setCopied(false);
      } else {
        alert(res.data.message || "Failed to generate API key");
      }
    } catch (err) {
      console.error(err);
      alert("Server error ❌");
    } finally {
      setLoading(false);
    }
  };

  const copyKey = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      alert("Copy failed ❌");
    }
  };

  return (
    <div className="apikey-page">
      <h2 className="apikey-title">API Key</h2>
      <p className="apikey-subtitle">
        Generate an API key to access VahanAPI services
      </p>

      <div className="apikey-box">
        {apiKey ? (
          <>
            <label className="apikey-label">Your API Key</label>

            <div className="apikey-row">
              <input
                type="text"
                value={apiKey}
                readOnly
                className="apikey-input"
              />

              <button onClick={copyKey} className="apikey-copy-btn">
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>

            <small className="apikey-note">
              Keep this key secret. Do not share it.
            </small>
          </>
        ) : (
          <button
            onClick={generateKey}
            disabled={loading}
            className="apikey-btn"
          >
            {loading ? "Generating..." : "Generate API Key"}
          </button>
        )}
      </div>
    </div>
  );
};

export default ApiKey;
